module.exports = __webpack_public_path__ + "img/clipboard_with_events.3a7ee70a.svg";